import Vue from 'vue'

const url = Vue.prototype.$config.api_url +
  Vue.prototype.$config.resources.task
const task = {
  create(payload:any) {
    return Vue.prototype.$httpService
      .post(url, payload)
  },
  edit( id:string|number, payload:any) {
    return Vue.prototype.$httpService
      .put(url + "/" + id, payload)
  },
  find(id:string|number) {
    return Vue.prototype.$httpService
      .get(url + "/" + id +"/detail")
  },
  delete(id:string|number) {
    return Vue.prototype.$httpService
      .delete(url + "/" + id)
  },
  list() {
    return Vue.prototype.$httpService.get(url)
  },
}

export default task;
